import './FiltersMobileSwitchPanel.css';
import React, { useContext } from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { ReactComponent as IconArrowLeft } from '../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../resources/icons/IconArrowRight.svg';
import { ReactComponent as IconChevronDown } from '../../../resources/icons/IconChevronDown.svg';
var commonStyles = "cysg60v";
var ltrStyles = "l25kosf";
var rtlStyles = "rkpui2x";
var FiltersMobileSwitchPanel = function FiltersMobileSwitchPanel(_ref) {
  var filterState = _ref.filterState,
    labelText = _ref.labelText,
    clearAll = _ref.clearAll,
    ctaText = _ref.ctaText,
    togglePanel = _ref.togglePanel,
    panelVisible = _ref.panelVisible,
    clearFilter = _ref.clearFilter,
    triggerFilterFieldOpen = _ref.triggerFilterFieldOpen;
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, /*#__PURE__*/React.createElement("button", {
    className: "panel-trigger",
    onClick: togglePanel
  }, labelText), /*#__PURE__*/React.createElement("div", {
    className: "\n      filters__mobile-items-wrapper\n      ".concat(panelVisible ? 'filters__mobile-items-wrapper--visible' : '', "\n    ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-lg-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: togglePanel
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, labelText), /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__clear",
    onClick: clearFilter
  }, clearAll)), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters__mobile-list"
  }, Object.keys(filterState).map(function (key) {
    if (filterState[key].filterTemplate !== 'Dropdown Multi Select' && filterState[key].filterTemplate !== 'Date Range') {
      return null;
    }
    return /*#__PURE__*/React.createElement("button", {
      className: "filters__mobile-list-button",
      key: key,
      onClick: function onClick() {
        triggerFilterFieldOpen(key);
      }
    }, /*#__PURE__*/React.createElement("h5", null, filterState[key].title), /*#__PURE__*/React.createElement("p", null, filterState[key].title), /*#__PURE__*/React.createElement(IconChevronDown, {
      className: "icon"
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-footer d-lg-none"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: togglePanel
  }, ctaText))));
};
export default FiltersMobileSwitchPanel;